export const getUtm = () =>
  !localStorage?.getItem('utm') || localStorage?.getItem('utm') === 'undefined'
    ? null
    : JSON.parse(`${localStorage?.getItem('utm')}`);
